'use client';
import { imageData } from '@/config/defaultBlur';
import { PAGE_QUERY_RESULT } from '@/sanity.types';
import { urlForImage } from '@/sanity/lib/utils';
import Image from 'next/image';
import React from 'react';
import { Carousel } from 'react-bootstrap';
import './wideDisplay.scss';
import Link from 'next/link';
import { FaCaretLeft, FaCaretRight } from 'react-icons/fa';

type wideCarouselType = Extract<
  NonNullable<NonNullable<PAGE_QUERY_RESULT>['content']>[number],
  { _type: 'wideCarousel' }
>;

type sidesType = wideCarouselType['slides'];

type CarouselDisplayProps = {
  slides: sidesType;
};
export const WideDisplay = ({ slides }: CarouselDisplayProps) => {
  return (
    <Carousel
      fade
      className="wide-carousel"
      prevIcon={
        <span className="wide-carousel__control-icon" aria-hidden="true">
          <FaCaretLeft />
        </span>
      }
      nextIcon={
        <span className="wide-carousel__control-icon" aria-hidden="true">
          <FaCaretRight />
        </span>
      }
    >
      {slides?.map((slide, index) => (
        <Carousel.Item key={index}>
          <Link href={slide?.link || ''} target={slide?.target ? '_blank' : ''}>
            <Image
              src={
                slide?.wideCarouselImage
                  ? (urlForImage(slide.wideCarouselImage)?.url() as string)
                  : ''
              }
              alt={slide?.wideCarouselImage?.alt || ''}
              width={600}
              height={600}
              sizes="100vw"
              className="carousel-small-image fade-in-out"
              placeholder="blur"
              blurDataURL={
                slide?.wideCarouselImage?.imgAsset?.metadata?.lqip ||
                imageData.blurImage
              }
            />
          </Link>
          <Carousel.Caption>
            <Link
              href={slide?.link || ''}
              target={slide?.target ? '_blank' : ''}
            >
              <h4>{slide?.title}</h4>
            </Link>
            <p>{slide?.Description}</p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};
